import React, { useContext, useState } from "react"
import * as S from "./demo-drawer.styles.jsx"
import { Close } from "@mui/icons-material"
import { colorsContext } from "../../provider"
import { useMediaQuery, useTheme } from "@mui/material"
import CloseIcon from "../../assets/close.svg"
import BookDemoFormTreez from "../book-demo-form-treez/book-demo-form-treez.component"

const DemoDrawer = () => {
  const { isFormDrawerOpen, setIsFormDrawerOpen } = useContext(colorsContext)
  const theme = useTheme()
  const isMD = useMediaQuery(theme.breakpoints.down("sm"))
  const [successMessage, setSuccessMessage] = useState(null)
  return (
    <S.Wrapper
      anchor="right"
      open={isFormDrawerOpen}
      transitionDuration={700}
      onClose={() => setIsFormDrawerOpen(false)}
    >
      <S.InnerWrapper>
        <S.InfoWrapper>
          {isMD ? (
            <S.LogoContainerMobile>
              {/*<S.ShortLogo />*/}
              <S.CloseButton onClick={() => setIsFormDrawerOpen(false)}>
                <CloseIcon />
              </S.CloseButton>
            </S.LogoContainerMobile>
          ) : (
            <S.LogoContainer>
              <S.CloseButton onClick={() => setIsFormDrawerOpen(false)}>
                <CloseIcon />
              </S.CloseButton>
            </S.LogoContainer>
          )}
          <S.Title>Book a Demo</S.Title>
          <S.Description>
            Schedule a demo today and witness the winning combination for your
            dispenary.
          </S.Description>
          <S.SmallText>
            Choose Mosaic + Treez and get 6 months of Mosaic free, or a free
            website and brand refresh.
          </S.SmallText>
        </S.InfoWrapper>
        <S.FormWrapper>
          {!successMessage ? (
            <BookDemoFormTreez setSuccessMessage={setSuccessMessage} />
          ) : (
            <S.SuccessMessage>
              <p>{successMessage}</p>
            </S.SuccessMessage>
          )}
        </S.FormWrapper>
      </S.InnerWrapper>
    </S.Wrapper>
  )
}
export default DemoDrawer
